import React from 'react';
import {observer} from "mobx-react";
import {FreePlayContainerComponent} from "../../../free-play/free-play-container.component";
import {FreePlaySlideBox} from "./boxes/free-play-slide.box";

interface FreePlaySlideComponentProps {

}
export const FreePlaySlideComponent: React.FC<FreePlaySlideComponentProps> = observer(() => {

    return <FreePlaySlideBox>
        <FreePlayContainerComponent/>
    </FreePlaySlideBox>
})